import React, {useCallback, useEffect, useState} from "react";
import {axiosInstance} from "../utilities/AxiosConfig";
import Cookies from "js-cookie";
import {notify} from "../components/toast";
import {ToastContainer} from "react-toastify";
import {MunshiMenu} from "../components/Menu";
import dayjs from "dayjs";

import KitPanel from "../components/Kit/KitPanel";
import {useSpinner} from "../context/SpinnerContext";
import {Auths} from "../utilities/getAuthDep";


export const Kit = ({handle}) => {
    const {loading, setLoading} = useSpinner()
    const [kitList, setKitList] = useState([]);
    const [itemList, setItemList] = useState([]);
    const [companyName, setCompanyName] = useState("");
    const [level] = useState(Auths);
    const [user, setUser] = useState("Guest");
    const [database, setDatabase] = useState("Test");

    useEffect(() => {

        setUser(Cookies.get('user') || "Guest");
        setDatabase(Cookies.get('database') || "Test");
    }, [])
    useEffect(() => {
        setLoading(true)
        axiosInstance.get(`biodata/`,).then((response) => {
            setCompanyName(response.data.name)
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            () => {
                setLoading(false)
            }
        )
    }, []);
    useEffect(() => {
        setLoading(true)
        axiosInstance.get('/kit/').then((response) => {
            setKitList(response.data)
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            setLoading(false)
        )
    }, [])
    useEffect(() => {
        setLoading(true)
        axiosInstance.get('/item/basic/').then((response) => {
            setItemList(response.data)
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            setLoading(false)
        )
    }, [])
    const saveKit = (kit) => {

        setLoading(true)
        axiosInstance.post(`/kit/`, kit).then((response) => {
            setKitList(kit)
            notify(response.data, "success")
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            setLoading(false)
        )
    }

    const KitSelect = () => {
        if (kitList && itemList && !loading) {
            return (
                <>
                    <KitPanel kitList={kitList} setKitList={setKitList} saveKit={(kit) => saveKit(kit)}
                              itemList={itemList.map((item) => {
                                  return {
                                      id: item.id,
                                      name: item.name,

                                  }
                              })}
                    />
                </>

            )
        } else {
            return null
        }
    }
    if (!loading && itemList && kitList && itemList.length > 0) {
        return (
            <>
                <ToastContainer/>
                <MunshiMenu handle={handle}/>

                    <KitSelect/>

            </>
        );
    }

}